module.exports = __webpack_public_path__ + "media/images/urd_template-aacd2b875ed17bd51c9eacca351b4d15.png";